import { keepPreviousData, queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  CampaignLaunchAudience,
  CampaignLaunchAudienceResponseDataSchema,
  DataResponse,
} from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof CampaignLaunchAudienceResponseDataSchema>>

type Props = {
  campaignId: string
  audienceSource: CampaignLaunchAudience | undefined
}

export const campaignLaunchAudienceQuery = ({ campaignId, audienceSource }: Props) => {
  return queryOptions({
    queryKey: ["campaigns", campaignId, "launchAudience", audienceSource],
    queryFn: async () => {
      const response = await axios.post<Response>(`/campaigns/${campaignId}/launches/audience`, {
        audienceSource,
      })
      return response.data.data
    },
    enabled: Boolean(audienceSource),
    placeholderData: keepPreviousData,
  })
}
